/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online tool to remove duplicate lines from a list or text. Keep the original order or sort alphabetically, ignore case, trim lines, and drop blanks. Works in your browser.`)
};

const es_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta en línea gratuita para eliminar líneas duplicadas de una lista o texto. Mantén el orden original u ordena alfabéticamente, ignora mayúsculas, recorta líneas y elimina espacios en blanco. Funciona en tu navegador.`)
};

const de_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Online-Tool zum Entfernen doppelter Zeilen aus einer Liste oder einem Text. Behalten Sie die ursprüngliche Reihenfolge bei oder sortieren Sie alphabetisch, ignorieren Sie die Groß-/Kleinschreibung, trimmen Sie Zeilen und entfernen Sie Leerzeilen. Funktioniert in Ihrem Browser.`)
};

const nl_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online tool om dubbele regels uit een lijst of tekst te verwijderen. Behoud de oorspronkelijke volgorde of sorteer alfabetisch, negeer hoofdlettergevoeligheid, trim regels en laat lege regels weg. Werkt in uw browser.`)
};

const fr_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil en ligne gratuit pour supprimer les lignes en doublon d'une liste ou d'un texte. Conservez l'ordre d'origine ou triez alphabétiquement, ignorez la casse, supprimez les espaces et supprimez les lignes vides. Fonctionne dans votre navigateur.`)
};

const it_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento online gratuito per rimuovere righe duplicate da un elenco o testo. Mantieni l'ordine originale o ordina alfabeticamente, ignora maiuscole/minuscole, rimuovi spazi dalle righe e elimina i vuoti. Funziona nel tuo browser.`)
};

const pt_br2_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta online gratuita para remover linhas duplicadas de uma lista ou texto. Mantenha a ordem original ou classifique alfabeticamente, ignore maiúsculas, aparar linhas e remova em branco. Funciona no seu navegador.`)
};

const pt_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta online gratuita para remover linhas duplicadas de uma lista ou texto. Mantenha a ordem original ou ordene alfabeticamente, ignore maiúsculas, apare linhas e elimine em branco. Funciona no seu navegador.`)
};

const ja_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストまたはテキストから重複行を削除する無料オンラインツール。元の順序を保持またはアルファベット順にソート、大文字小文字を無視、トリム、空白行を削除します。ブラウザで動作します。`)
};

const zh_rd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线工具，可去除列表或文本中的重复行。保留原始顺序或按字母排序，忽略大小写，去除首尾空格，并删除空行。全部在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_meta_description", locale)
	if (locale === "en") return en_rd_meta_description(inputs)
	if (locale === "es") return es_rd_meta_description(inputs)
	if (locale === "de") return de_rd_meta_description(inputs)
	if (locale === "nl") return nl_rd_meta_description(inputs)
	if (locale === "fr") return fr_rd_meta_description(inputs)
	if (locale === "it") return it_rd_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_rd_meta_description(inputs)
	if (locale === "pt") return pt_rd_meta_description(inputs)
	if (locale === "ja") return ja_rd_meta_description(inputs)
	return zh_rd_meta_description(inputs)
};